<template>
  <div>
    <v-btn @click.stop="setDialog(true)" class="ma-1" color="primary" small text data-cy="valueListDialog"
      >{{ groupedDropdownLabel }} Values: {{ valueList.length }}</v-btn
    >
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <v-card-title class="headline font-weight-thin">
          <div>
            <strong data-cy="dialogTitle">{{ dropdownValueLabel }}</strong>
          </div>
        </v-card-title>

        <v-card-title class="mt-n5">
          <div class="subtitle-1">{{ valueList.length }} {{ groupedDropdownLabel }} Value(s)</div>
        </v-card-title>

        <v-card-text>
          <ul>
            <li v-for="item in valueList" :key="item.id">
              {{ item.label }}
            </li>
          </ul>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn @click="setDialog(false)" class="mr-2" outlined>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  computed: {
    titleDisplayText() {
      const count = this.valueList.length;
      const verb = count === 1 ? "Value" : "Values";
      return `${count} ${this.groupedDropdownLabel} ${verb} Using ${this.dropdownValueLabel}`;
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    dropdownValueLabel: { required: true, type: String },
    groupedDropdownLabel: { required: true, type: String },
    valueList: { required: true, type: Array },
  },
};
</script>
